import React from 'react';
import { Route } from 'react-router';

import MailchimpConnectPage from './MailchimpConnectionPage';
import MailchimpSettingsPage from './MailchimpSettingsPage';
import { BRAND_USER_BASE_URL, SHOP_USER_BASE_URL } from '../../../../constants';
import BrandMailchimpIntegration from './BrandMailchimpIntegrationContainer';
import ShopMailchimpIntegration from './ShopMailchimpIntegrationContainer';
import { requireMailchimpConnectionState } from './routerHooks';
import { CONNECT, INTEGRATIONS_PATH, MAILCHIMP_PATH, SETTINGS } from '../constants';

const MailchimpIntegrationSettingsRoutes = (store, baseUrl) => (
  <React.Fragment>
    <Route
      path={CONNECT}
      component={MailchimpConnectPage}
      onEnter={requireMailchimpConnectionState(store, SETTINGS, `${baseUrl}/${INTEGRATIONS_PATH}${MAILCHIMP_PATH}`)}
    />
    <Route
      path={SETTINGS}
      component={MailchimpSettingsPage}
      onEnter={requireMailchimpConnectionState(store, CONNECT, `${baseUrl}/${INTEGRATIONS_PATH}${MAILCHIMP_PATH}`)}
    />
  </React.Fragment>
);

export const ShopMailchimpRoutes = store => (
  <Route
    path="mailchimp"
    baseUrl={SHOP_USER_BASE_URL}
    component={ShopMailchimpIntegration}
  >
    {MailchimpIntegrationSettingsRoutes(store, SHOP_USER_BASE_URL)}
  </Route>
);

export const BrandMailchimpRoutes = store => (
  <Route
    path="mailchimp"
    baseUrl={BRAND_USER_BASE_URL}
    component={BrandMailchimpIntegration}
  >
    {MailchimpIntegrationSettingsRoutes(store, BRAND_USER_BASE_URL)}
  </Route>
);
